module.exports = function (breakpointsService) {
    return {
        restrict: 'E',
        link($scope) {
            $scope.isSmallFormat = function () {
                return breakpointsService.isSmallFormat();
            };
        },
        template: require('./accessibility-nav-links.directive.html').trim(),
    };
};



// WEBPACK FOOTER //
// ./src/shop/accessibility/accessibility-nav-links.directive.js